import { render } from "./RepairsPage.vue?vue&type=template&id=badcc33a&scoped=true"
import script from "./RepairsPage.vue?vue&type=script&lang=js"
export * from "./RepairsPage.vue?vue&type=script&lang=js"

import "./RepairsPage.vue?vue&type=style&index=0&id=badcc33a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-badcc33a"]])

export default __exports__